import React, {ReactElement, useContext} from 'react';

import {CountryContext, CountrySetterContext} from '../utils/CountryContext';
import {PricePoint, WatchFaceContext} from './WatchFaceContext';

type PriceInCountry = {
  countryName: string;
  priceNum: number;
  priceStr: string;
};

const REGIONAL_PRICES: {
  [key in NonNullable<PricePoint>]: Record<string, PriceInCountry>;
} = {
  1.99: {
    AR: {countryName: 'Argentina', priceNum: 2099, priceStr: 'AR$2099'},
    AT: {countryName: 'Austria', priceNum: 2.49, priceStr: '€2.49'},
    AU: {countryName: 'Australia', priceNum: 3.25, priceStr: 'A$3.25'},
    BE: {countryName: 'Belgium', priceNum: 2.49, priceStr: '€2.49'},
    CA: {countryName: 'Canada', priceNum: 3.49, priceStr: 'CA$3.49'},
    CH: {countryName: 'Switzerland', priceNum: 2.0, priceStr: 'CHF 2.00'},
    CL: {countryName: 'Chile', priceNum: 2.49, priceStr: '€2.49'},
    CY: {countryName: 'Cyprus', priceNum: 2.49, priceStr: '€2.49'},
    CZ: {countryName: 'Czech Republic', priceNum: 69, priceStr: 'Kč 69'},
    DE: {countryName: 'Germany', priceNum: 2.49, priceStr: '€2.49'},
    DK: {countryName: 'Denmark', priceNum: 18.5, priceStr: 'kr. 18.50'},
    EE: {countryName: 'Estonia', priceNum: 2.49, priceStr: '€2.49'},
    ES: {countryName: 'Spain', priceNum: 2.49, priceStr: '€2.49'},
    FI: {countryName: 'Finland', priceNum: 2.49, priceStr: '€2.49'},
    FR: {countryName: 'France', priceNum: 2.49, priceStr: '€2.49'},
    GB: {countryName: 'United Kingdom', priceNum: 1.99, priceStr: '£1.99'},
    GR: {countryName: 'Greece', priceNum: 2.49, priceStr: '€2.49'},
    IE: {countryName: 'Ireland', priceNum: 2.49, priceStr: '€2.49'},
    IT: {countryName: 'Italy', priceNum: 2.49, priceStr: '€2.49'},
    LT: {countryName: 'Lithuania', priceNum: 2.49, priceStr: '€2.49'},
    LU: {countryName: 'Luxembourg', priceNum: 2.49, priceStr: '€2.49'},
    LV: {countryName: 'Latvia', priceNum: 2.49, priceStr: '€2.49'},
    MT: {countryName: 'Malta', priceNum: 2.49, priceStr: '€2.49'},
    MX: {countryName: 'Mexico', priceNum: 39.25, priceStr: 'MX$39.25'},
    NL: {countryName: 'Netherlands', priceNum: 2.49, priceStr: '€2.49'},
    NO: {countryName: 'Norway', priceNum: 28, priceStr: 'kr 28'},
    NZ: {countryName: 'New Zealand', priceNum: 3.49, priceStr: 'NZ$3.49'},
    PT: {countryName: 'Portugal', priceNum: 2.49, priceStr: '€2.49'},
    RO: {countryName: 'Romania', priceNum: 19, priceStr: 'lei 19'},
    SE: {countryName: 'Sweden', priceNum: 28, priceStr: 'kr 28'},
    SI: {countryName: 'Slovenia', priceNum: 2.49, priceStr: '€2.49'},
    SK: {countryName: 'Slovakia', priceNum: 2.49, priceStr: '€2.49'},
    TH: {countryName: 'Thailand', priceNum: 79, priceStr: '฿79'},
    US: {countryName: 'United States', priceNum: 1.99, priceStr: '$1.99'},
    VN: {countryName: 'Vietnam', priceNum: 55699, priceStr: '₫55,699'},
  },
  3.49: {},
  4.99: {
    AR: {countryName: 'Argentina', priceNum: 5099, priceStr: 'AR$5099'},
    AT: {countryName: 'Austria', priceNum: 5.99, priceStr: '€5.99'},
    AU: {countryName: 'Australia', priceNum: 7.99, priceStr: 'A$7.99'},
    BE: {countryName: 'Belgium', priceNum: 5.99, priceStr: '€5.99'},
    CA: {countryName: 'Canada', priceNum: 8.49, priceStr: 'CA$8.49'},
    CH: {countryName: 'Switzerland', priceNum: 5.2, priceStr: 'CHF 5.20'},
    CL: {countryName: 'Chile', priceNum: 5.99, priceStr: '€5.99'},
    CY: {countryName: 'Cyprus', priceNum: 5.99, priceStr: '€5.99'},
    CZ: {countryName: 'Czech Republic', priceNum: 159, priceStr: 'Kč 159'},
    DE: {countryName: 'Germany', priceNum: 5.99, priceStr: '€5.99'},
    DK: {countryName: 'Denmark', priceNum: 45.5, priceStr: 'kr. 45.50'},
    EE: {countryName: 'Estonia', priceNum: 5.99, priceStr: '€5.99'},
    ES: {countryName: 'Spain', priceNum: 5.99, priceStr: '€5.99'},
    FI: {countryName: 'Finland', priceNum: 5.99, priceStr: '€5.99'},
    FR: {countryName: 'France', priceNum: 5.99, priceStr: '€5.99'},
    GB: {countryName: 'United Kingdom', priceNum: 4.99, priceStr: '£4.99'},
    GR: {countryName: 'Greece', priceNum: 5.99, priceStr: '€5.99'},
    IE: {countryName: 'Ireland', priceNum: 5.99, priceStr: '€5.99'},
    IT: {countryName: 'Italy', priceNum: 5.99, priceStr: '€5.99'},
    LT: {countryName: 'Lithuania', priceNum: 5.99, priceStr: '€5.99'},
    LU: {countryName: 'Luxembourg', priceNum: 5.99, priceStr: '€5.99'},
    LV: {countryName: 'Latvia', priceNum: 5.99, priceStr: '€5.99'},
    MT: {countryName: 'Malta', priceNum: 5.99, priceStr: '€5.99'},
    MX: {countryName: 'Mexico', priceNum: 97.99, priceStr: 'MX$97.99'},
    NL: {countryName: 'Netherlands', priceNum: 5.99, priceStr: '€5.99'},
    NO: {countryName: 'Norway', priceNum: 70, priceStr: 'kr 70'},
    NZ: {countryName: 'New Zealand', priceNum: 8.75, priceStr: 'NZ$8.75'},
    PT: {countryName: 'Portugal', priceNum: 5.99, priceStr: '€5.99'},
    RO: {countryName: 'Romania', priceNum: 39, priceStr: 'lei 39'},
    SE: {countryName: 'Sweden', priceNum: 70, priceStr: 'kr 70'},
    SI: {countryName: 'Slovenia', priceNum: 5.99, priceStr: '€5.99'},
    SK: {countryName: 'Slovakia', priceNum: 5.99, priceStr: '€5.99'},
    TH: {countryName: 'Thailand', priceNum: 199, priceStr: '฿199'},
    US: {countryName: 'United States', priceNum: 4.99, priceStr: '$4.99'},
    VN: {countryName: 'Vietnam', priceNum: 139099, priceStr: '₫139,099'},
  },
};

export type RegionalPrice = {
  currency: string;
  priceNumber: number;
  priceString: string;
};

export function useRegionalPrice(): RegionalPrice | null {
  const countryCtx = useContext(CountryContext);
  const watchFaceCtx = useContext(WatchFaceContext);

  if (watchFaceCtx.priceUsd === null) {
    return null;
  }

  const countryCode = countryCtx.countryCode ?? '';

  const regionalPrice = REGIONAL_PRICES[watchFaceCtx.priceUsd][countryCode];

  if (!regionalPrice) {
    // Fallback to USD price if regional price is not available
    return {
      currency: 'USD',
      priceNumber: watchFaceCtx.priceUsd,
      priceString: `$${watchFaceCtx.priceUsd}`,
    };
  }

  return {
    currency: currencyMapping[countryCode] ?? '',
    priceNumber: regionalPrice.priceNum,
    priceString: regionalPrice.priceStr,
  };
}

type CountrySelectorProps = {};

export function CountrySelector({}: CountrySelectorProps): ReactElement | null {
  const countryCtx = useContext(CountryContext);
  const watchFaceCtx = useContext(WatchFaceContext);
  const countrySetterCtx = useContext(CountrySetterContext);

  if (watchFaceCtx.priceUsd === null) {
    return null;
  }

  const regionalPrices = REGIONAL_PRICES[watchFaceCtx.priceUsd];

  const selectedValue =
    countryCtx.countryCode && countryCtx.countryCode in regionalPrices
      ? countryCtx.countryCode
      : 'none';

  return (
    <p className="country-selector-paragraph">
      <small>
        Price in{' '}
        <select
          value={selectedValue}
          onChange={e => countrySetterCtx.setCountryCode(e.target.value)}>
          <option value="none" disabled>
            select country
          </option>
          {Object.entries(regionalPrices).map(([id, e]) => (
            <option key={`country-${id}`} value={id}>
              {e.countryName}
            </option>
          ))}
        </select>
        {countryCtx.hasManuallyChangedCountry && (
          <span className="price-disclaimer">
            <br />
            Regional pricing is determined by Garmin and is outside of our
            control.
          </span>
        )}
      </small>
    </p>
  );
}

// ISO 4217 currency codes: https://en.wikipedia.org/wiki/ISO_4217
const currencyMapping: Record<string, string> = {
  AR: 'ARS',
  AT: 'EUR',
  AU: 'AUD',
  BE: 'EUR',
  CA: 'CAD',
  CH: 'CHF',
  CL: 'EUR',
  CY: 'EUR',
  CZ: 'CZK',
  DE: 'EUR',
  DK: 'DKK',
  EE: 'EUR',
  ES: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  GB: 'GBP',
  GR: 'EUR',
  IE: 'EUR',
  IT: 'EUR',
  LT: 'EUR',
  LU: 'EUR',
  LV: 'EUR',
  MT: 'EUR',
  MX: 'MXN',
  NL: 'EUR',
  NO: 'NOK',
  NZ: 'NZD',
  PT: 'EUR',
  RO: 'RON',
  SE: 'SEK',
  SI: 'EUR',
  SK: 'EUR',
  TH: 'THB',
  US: 'USD',
  VN: 'VND',
};

/*
ARS
Price Point	Argentina
USD $2.00	2099 ARS
USD $2.25	2299 ARS
USD $2.50	2599 ARS
USD $2.75	2799 ARS
USD $3.00	3099 ARS
USD $3.25	3299 ARS
USD $3.50	3599 ARS
USD $3.75	3799 ARS
USD $4.00	4099 ARS
USD $4.25	4299 ARS
USD $4.50	4599 ARS
USD $4.75	4799 ARS
USD $5.00	5099 ARS
USD $5.25	5299 ARS
USD $5.50	5599 ARS
USD $5.75	5799 ARS
USD $6.00	6099 ARS
USD $6.25	6299 ARS
USD $6.50	6599 ARS
USD $6.75	6799 ARS
USD $7.00	7099 ARS
USD $7.25	7299 ARS
USD $7.50	7599 ARS
USD $7.75	7799 ARS
USD $8.00	8099 ARS
USD $8.25	8299 ARS
USD $8.50	8599 ARS
USD $8.75	8799 ARS
USD $9.00	9099 ARS
USD $9.25	9299 ARS
USD $9.50	9599 ARS
USD $9.75	9799 ARS
USD $10.00	10099 ARS
USD $11.00	11099 ARS
USD $12.00	12099 ARS
USD $13.00	13099 ARS
USD $14.00	14099 ARS
USD $15.00	15099 ARS
USD $16.00	16099 ARS
USD $17.00	17099 ARS
USD $18.00	18099 ARS
USD $19.00	19099 ARS
USD $20.00	20099 ARS
USD $21.00	21099 ARS
USD $22.00	22099 ARS
USD $23.00	23099 ARS
USD $24.00	24099 ARS
USD $25.00	25099 ARS
USD $26.00	26099 ARS
USD $27.00	27099 ARS
USD $28.00	28099 ARS
USD $29.00	29099 ARS
USD $30.00	30199 ARS
USD $31.00	31199 ARS
USD $32.00	32199 ARS
USD $33.00	33199 ARS
USD $34.00	34199 ARS
USD $35.00	35199 ARS
USD $36.00	36199 ARS
USD $37.00	37199 ARS
USD $38.00	38199 ARS
USD $39.00	39199 ARS
USD $40.00	40199 ARS
USD $41.00	41199 ARS
USD $42.00	42199 ARS
USD $43.00	43199 ARS
USD $44.00	44199 ARS
USD $45.00	45199 ARS
USD $46.00	46199 ARS
USD $47.00	47199 ARS
USD $48.00	48199 ARS
USD $49.00	49199 ARS
USD $50.00	50199 ARS
USD $60.00	60299 ARS
USD $70.00	70299 ARS
USD $80.00	80299 ARS
USD $90.00	90399 ARS
USD $100.00	100399 ARS
AUD
Price Point	Australia
USD $2.00	3.25 AUD
USD $2.25	3.75 AUD
USD $2.50	3.99 AUD
USD $2.75	4.49 AUD
USD $3.00	4.75 AUD
USD $3.25	5.25 AUD
USD $3.50	5.49 AUD
USD $3.75	5.99 AUD
USD $4.00	6.49 AUD
USD $4.25	6.75 AUD
USD $4.50	7.25 AUD
USD $4.75	7.49 AUD
USD $5.00	7.99 AUD
USD $5.25	8.25 AUD
USD $5.50	8.75 AUD
USD $5.75	8.99 AUD
USD $6.00	9.49 AUD
USD $6.25	9.99 AUD
USD $6.50	10.25 AUD
USD $6.75	10.75 AUD
USD $7.00	10.99 AUD
USD $7.25	11.49 AUD
USD $7.50	11.75 AUD
USD $7.75	12.25 AUD
USD $8.00	12.75 AUD
USD $8.25	12.99 AUD
USD $8.50	13.49 AUD
USD $8.75	13.75 AUD
USD $9.00	14.25 AUD
USD $9.25	14.49 AUD
USD $9.50	14.99 AUD
USD $9.75	15.49 AUD
USD $10.00	15.75 AUD
USD $11.00	17.25 AUD
USD $12.00	18.99 AUD
USD $13.00	20.49 AUD
USD $14.00	21.99 AUD
USD $15.00	23.49 AUD
USD $16.00	25.25 AUD
USD $17.00	26.75 AUD
USD $18.00	28.25 AUD
USD $19.00	29.99 AUD
USD $20.00	31.49 AUD
USD $21.00	32.99 AUD
USD $22.00	34.49 AUD
USD $23.00	36.25 AUD
USD $24.00	37.75 AUD
USD $25.00	39.25 AUD
USD $26.00	40.75 AUD
USD $27.00	42.49 AUD
USD $28.00	43.99 AUD
USD $29.00	45.49 AUD
USD $30.00	46.99 AUD
USD $31.00	48.75 AUD
USD $32.00	50.25 AUD
USD $33.00	51.75 AUD
USD $34.00	53.25 AUD
USD $35.00	54.99 AUD
USD $36.00	56.49 AUD
USD $37.00	57.99 AUD
USD $38.00	59.75 AUD
USD $39.00	61.25 AUD
USD $40.00	62.75 AUD
USD $41.00	64.25 AUD
USD $42.00	65.99 AUD
USD $43.00	67.49 AUD
USD $44.00	68.99 AUD
USD $45.00	70.49 AUD
USD $46.00	72.25 AUD
USD $47.00	73.75 AUD
USD $48.00	75.25 AUD
USD $49.00	76.75 AUD
USD $50.00	78.49 AUD
USD $60.00	93.99 AUD
USD $70.00	109.75 AUD
USD $80.00	125.49 AUD
USD $90.00	140.99 AUD
USD $100.00	156.75 AUD
CAD
Price Point	Canada
USD $2.00	3.49 CAD
USD $2.25	3.75 CAD
USD $2.50	4.25 CAD
USD $2.75	4.75 CAD
USD $3.00	4.99 CAD
USD $3.25	5.49 CAD
USD $3.50	5.99 CAD
USD $3.75	6.25 CAD
USD $4.00	6.75 CAD
USD $4.25	7.25 CAD
USD $4.50	7.49 CAD
USD $4.75	7.99 CAD
USD $5.00	8.49 CAD
USD $5.25	8.75 CAD
USD $5.50	9.25 CAD
USD $5.75	9.75 CAD
USD $6.00	9.99 CAD
USD $6.25	10.49 CAD
USD $6.50	10.75 CAD
USD $6.75	11.25 CAD
USD $7.00	11.75 CAD
USD $7.25	11.99 CAD
USD $7.50	12.49 CAD
USD $7.75	12.99 CAD
USD $8.00	13.25 CAD
USD $8.25	13.75 CAD
USD $8.50	14.25 CAD
USD $8.75	14.49 CAD
USD $9.00	14.99 CAD
USD $9.25	15.49 CAD
USD $9.50	15.75 CAD
USD $9.75	16.25 CAD
USD $10.00	16.75 CAD
USD $11.00	18.25 CAD
USD $12.00	19.99 CAD
USD $13.00	21.49 CAD
USD $14.00	23.25 CAD
USD $15.00	24.99 CAD
USD $16.00	26.49 CAD
USD $17.00	28.25 CAD
USD $18.00	29.99 CAD
USD $19.00	31.49 CAD
USD $20.00	33.25 CAD
USD $21.00	34.75 CAD
USD $22.00	36.49 CAD
USD $23.00	38.25 CAD
USD $24.00	39.75 CAD
USD $25.00	41.49 CAD
USD $26.00	42.99 CAD
USD $27.00	44.75 CAD
USD $28.00	46.49 CAD
USD $29.00	47.99 CAD
USD $30.00	49.75 CAD
USD $31.00	51.49 CAD
USD $32.00	52.99 CAD
USD $33.00	54.75 CAD
USD $34.00	56.25 CAD
USD $35.00	57.99 CAD
USD $36.00	59.75 CAD
USD $37.00	61.25 CAD
USD $38.00	62.99 CAD
USD $39.00	64.49 CAD
USD $40.00	66.25 CAD
USD $41.00	67.99 CAD
USD $42.00	69.49 CAD
USD $43.00	71.25 CAD
USD $44.00	72.99 CAD
USD $45.00	74.49 CAD
USD $46.00	76.25 CAD
USD $47.00	77.75 CAD
USD $48.00	79.49 CAD
USD $49.00	81.25 CAD
USD $50.00	82.75 CAD
USD $60.00	99.25 CAD
USD $70.00	115.99 CAD
USD $80.00	132.49 CAD
USD $90.00	148.99 CAD
USD $100.00	165.49 CAD
CHF
Price Point	Switzerland
USD $2.00	2.00 CHF
USD $2.25	2.30 CHF
USD $2.50	2.60 CHF
USD $2.75	2.80 CHF
USD $3.00	3.10 CHF
USD $3.25	3.30 CHF
USD $3.50	3.60 CHF
USD $3.75	3.90 CHF
USD $4.00	4.10 CHF
USD $4.25	4.40 CHF
USD $4.50	4.60 CHF
USD $4.75	4.90 CHF
USD $5.00	5.20 CHF
USD $5.25	5.40 CHF
USD $5.50	5.70 CHF
USD $5.75	5.90 CHF
USD $6.00	6.20 CHF
USD $6.25	6.50 CHF
USD $6.50	6.70 CHF
USD $6.75	7.00 CHF
USD $7.00	7.20 CHF
USD $7.25	7.50 CHF
USD $7.50	7.80 CHF
USD $7.75	8.00 CHF
USD $8.00	8.30 CHF
USD $8.25	8.50 CHF
USD $8.50	8.80 CHF
USD $8.75	9.10 CHF
USD $9.00	9.30 CHF
USD $9.25	9.60 CHF
USD $9.50	9.80 CHF
USD $9.75	10.10 CHF
USD $10.00	10.40 CHF
USD $11.00	11.40 CHF
USD $12.00	12.50 CHF
USD $13.00	13.50 CHF
USD $14.00	14.50 CHF
USD $15.00	15.60 CHF
USD $16.00	16.60 CHF
USD $17.00	17.70 CHF
USD $18.00	18.70 CHF
USD $19.00	19.70 CHF
USD $20.00	20.80 CHF
USD $21.00	21.80 CHF
USD $22.00	22.90 CHF
USD $23.00	23.90 CHF
USD $24.00	25.00 CHF
USD $25.00	26.00 CHF
USD $26.00	27.00 CHF
USD $27.00	28.10 CHF
USD $28.00	29.10 CHF
USD $29.00	30.20 CHF
USD $30.00	31.20 CHF
USD $31.00	32.20 CHF
USD $32.00	33.30 CHF
USD $33.00	34.30 CHF
USD $34.00	35.40 CHF
USD $35.00	36.40 CHF
USD $36.00	37.50 CHF
USD $37.00	38.50 CHF
USD $38.00	39.50 CHF
USD $39.00	40.60 CHF
USD $40.00	41.60 CHF
USD $41.00	42.70 CHF
USD $42.00	43.70 CHF
USD $43.00	44.70 CHF
USD $44.00	45.80 CHF
USD $45.00	46.80 CHF
USD $46.00	47.90 CHF
USD $47.00	48.90 CHF
USD $48.00	50.00 CHF
USD $49.00	51.00 CHF
USD $50.00	52.00 CHF
USD $60.00	62.50 CHF
USD $70.00	72.90 CHF
USD $80.00	83.30 CHF
USD $90.00	93.70 CHF
USD $100.00	104.10 CHF
CZK
Price Point	Czech Republic
USD $2.00	69.00 CZK
USD $2.25	69.00 CZK
USD $2.50	79.00 CZK
USD $2.75	89.00 CZK
USD $3.00	99.00 CZK
USD $3.25	99.00 CZK
USD $3.50	109.00 CZK
USD $3.75	119.00 CZK
USD $4.00	129.00 CZK
USD $4.25	139.00 CZK
USD $4.50	139.00 CZK
USD $4.75	149.00 CZK
USD $5.00	159.00 CZK
USD $5.25	169.00 CZK
USD $5.50	169.00 CZK
USD $5.75	179.00 CZK
USD $6.00	189.00 CZK
USD $6.25	199.00 CZK
USD $6.50	199.00 CZK
USD $6.75	209.00 CZK
USD $7.00	219.00 CZK
USD $7.25	229.00 CZK
USD $7.50	239.00 CZK
USD $7.75	239.00 CZK
USD $8.00	249.00 CZK
USD $8.25	259.00 CZK
USD $8.50	269.00 CZK
USD $8.75	269.00 CZK
USD $9.00	279.00 CZK
USD $9.25	289.00 CZK
USD $9.50	299.00 CZK
USD $9.75	299.00 CZK
USD $10.00	309.00 CZK
USD $11.00	339.00 CZK
USD $12.00	369.00 CZK
USD $13.00	399.00 CZK
USD $14.00	429.00 CZK
USD $15.00	469.00 CZK
USD $16.00	499.00 CZK
USD $17.00	529.00 CZK
USD $18.00	559.00 CZK
USD $19.00	589.00 CZK
USD $20.00	619.00 CZK
USD $21.00	649.00 CZK
USD $22.00	679.00 CZK
USD $23.00	709.00 CZK
USD $24.00	739.00 CZK
USD $25.00	769.00 CZK
USD $26.00	799.00 CZK
USD $27.00	829.00 CZK
USD $28.00	859.00 CZK
USD $29.00	889.00 CZK
USD $30.00	929.00 CZK
USD $31.00	959.00 CZK
USD $32.00	989.00 CZK
USD $33.00	1019.00 CZK
USD $34.00	1049.00 CZK
USD $35.00	1079.00 CZK
USD $36.00	1109.00 CZK
USD $37.00	1139.00 CZK
USD $38.00	1169.00 CZK
USD $39.00	1199.00 CZK
USD $40.00	1229.00 CZK
USD $41.00	1259.00 CZK
USD $42.00	1289.00 CZK
USD $43.00	1319.00 CZK
USD $44.00	1359.00 CZK
USD $45.00	1389.00 CZK
USD $46.00	1419.00 CZK
USD $47.00	1449.00 CZK
USD $48.00	1479.00 CZK
USD $49.00	1509.00 CZK
USD $50.00	1539.00 CZK
USD $60.00	1849.00 CZK
USD $70.00	2149.00 CZK
USD $80.00	2459.00 CZK
USD $90.00	2769.00 CZK
USD $100.00	3069.00 CZK
DKK
Price Point	Greenland	Denmark
USD $2.00	15.00 DKK	18.50 DKK
USD $2.25	16.50 DKK	20.50 DKK
USD $2.50	18.50 DKK	23.00 DKK
USD $2.75	20.50 DKK	25.50 DKK
USD $3.00	22.00 DKK	27.50 DKK
USD $3.25	24.00 DKK	30.00 DKK
USD $3.50	25.50 DKK	32.00 DKK
USD $3.75	27.50 DKK	34.50 DKK
USD $4.00	29.50 DKK	36.50 DKK
USD $4.25	31.00 DKK	39.00 DKK
USD $4.50	33.00 DKK	41.00 DKK
USD $4.75	35.00 DKK	43.50 DKK
USD $5.00	36.50 DKK	45.50 DKK
USD $5.25	38.50 DKK	48.00 DKK
USD $5.50	40.50 DKK	50.50 DKK
USD $5.75	42.00 DKK	52.50 DKK
USD $6.00	44.00 DKK	55.00 DKK
USD $6.25	45.50 DKK	57.00 DKK
USD $6.50	47.50 DKK	59.50 DKK
USD $6.75	49.50 DKK	61.50 DKK
USD $7.00	51.00 DKK	64.00 DKK
USD $7.25	53.00 DKK	66.00 DKK
USD $7.50	55.00 DKK	68.50 DKK
USD $7.75	56.50 DKK	70.50 DKK
USD $8.00	58.50 DKK	73.00 DKK
USD $8.25	60.50 DKK	75.50 DKK
USD $8.50	62.00 DKK	77.50 DKK
USD $8.75	64.00 DKK	80.00 DKK
USD $9.00	65.50 DKK	82.00 DKK
USD $9.25	67.50 DKK	84.50 DKK
USD $9.50	69.50 DKK	86.50 DKK
USD $9.75	71.00 DKK	89.00 DKK
USD $10.00	73.00 DKK	91.00 DKK
USD $11.00	80.50 DKK	100.50 DKK
USD $12.00	87.50 DKK	109.50 DKK
USD $13.00	95.00 DKK	118.50 DKK
USD $14.00	102.00 DKK	127.50 DKK
USD $15.00	109.50 DKK	136.50 DKK
USD $16.00	116.50 DKK	146.00 DKK
USD $17.00	124.00 DKK	155.00 DKK
USD $18.00	131.00 DKK	164.00 DKK
USD $19.00	138.50 DKK	173.00 DKK
USD $20.00	146.00 DKK	182.00 DKK
USD $21.00	153.00 DKK	191.50 DKK
USD $22.00	160.50 DKK	200.50 DKK
USD $23.00	167.50 DKK	209.50 DKK
USD $24.00	175.00 DKK	218.50 DKK
USD $25.00	182.00 DKK	227.50 DKK
USD $26.00	189.50 DKK	236.50 DKK
USD $27.00	196.50 DKK	246.00 DKK
USD $28.00	204.00 DKK	255.00 DKK
USD $29.00	211.50 DKK	264.00 DKK
USD $30.00	218.50 DKK	273.00 DKK
USD $31.00	226.00 DKK	282.00 DKK
USD $32.00	233.00 DKK	291.50 DKK
USD $33.00	240.50 DKK	300.50 DKK
USD $34.00	247.50 DKK	309.50 DKK
USD $35.00	255.00 DKK	318.50 DKK
USD $36.00	262.00 DKK	327.50 DKK
USD $37.00	269.50 DKK	337.00 DKK
USD $38.00	277.00 DKK	346.00 DKK
USD $39.00	284.00 DKK	355.00 DKK
USD $40.00	291.50 DKK	364.00 DKK
USD $41.00	298.50 DKK	373.00 DKK
USD $42.00	306.00 DKK	382.50 DKK
USD $43.00	313.00 DKK	391.50 DKK
USD $44.00	320.50 DKK	400.50 DKK
USD $45.00	327.50 DKK	409.50 DKK
USD $46.00	335.00 DKK	418.50 DKK
USD $47.00	342.50 DKK	428.00 DKK
USD $48.00	349.50 DKK	437.00 DKK
USD $49.00	357.00 DKK	446.00 DKK
USD $50.00	364.00 DKK	455.00 DKK
USD $60.00	437.00 DKK	546.00 DKK
USD $70.00	509.50 DKK	637.00 DKK
USD $80.00	582.50 DKK	728.00 DKK
USD $90.00	655.00 DKK	819.00 DKK
USD $100.00	728.00 DKK	910.00 DKK
EUR
Price Point	France, Germany, Italy, Portugal, Spain
USD $2.00	2.49 EUR
USD $2.25	2.69 EUR
USD $2.50	2.99 EUR
USD $2.75	3.29 EUR
USD $3.00	3.49 EUR
USD $3.25	3.99 EUR
USD $3.50	3.99 EUR
USD $3.75	4.49 EUR
USD $4.00	4.69 EUR
USD $4.25	4.99 EUR
USD $4.50	5.29 EUR
USD $4.75	5.49 EUR
USD $5.00	5.99 EUR
USD $5.25	5.99 EUR
USD $5.50	6.49 EUR
USD $5.75	6.69 EUR
USD $6.00	6.99 EUR
USD $6.25	7.29 EUR
USD $6.50	7.49 EUR
USD $6.75	7.99 EUR
USD $7.00	7.99 EUR
USD $7.25	8.49 EUR
USD $7.50	8.69 EUR
USD $7.75	8.99 EUR
USD $8.00	9.29 EUR
USD $8.25	9.49 EUR
USD $8.50	9.99 EUR
USD $8.75	9.99 EUR
USD $9.00	10.49 EUR
USD $9.25	10.69 EUR
USD $9.50	10.99 EUR
USD $9.75	11.29 EUR
USD $10.00	11.49 EUR
USD $11.00	12.69 EUR
USD $12.00	13.99 EUR
USD $13.00	14.99 EUR
USD $14.00	15.99 EUR
USD $15.00	17.29 EUR
USD $16.00	18.49 EUR
USD $17.00	19.49 EUR
USD $18.00	20.69 EUR
USD $19.00	21.99 EUR
USD $20.00	22.99 EUR
USD $21.00	23.99 EUR
USD $22.00	25.29 EUR
USD $23.00	26.49 EUR
USD $24.00	27.49 EUR
USD $25.00	28.69 EUR
USD $26.00	29.99 EUR
USD $27.00	30.99 EUR
USD $28.00	31.99 EUR
USD $29.00	33.29 EUR
USD $30.00	34.49 EUR
USD $31.00	35.49 EUR
USD $32.00	36.69 EUR
USD $33.00	37.99 EUR
USD $34.00	38.99 EUR
USD $35.00	40.29 EUR
USD $36.00	41.29 EUR
USD $37.00	42.49 EUR
USD $38.00	43.49 EUR
USD $39.00	44.69 EUR
USD $40.00	45.99 EUR
USD $41.00	46.99 EUR
USD $42.00	48.29 EUR
USD $43.00	49.29 EUR
USD $44.00	50.49 EUR
USD $45.00	51.49 EUR
USD $46.00	52.69 EUR
USD $47.00	53.99 EUR
USD $48.00	54.99 EUR
USD $49.00	56.29 EUR
USD $50.00	57.29 EUR
USD $60.00	68.69 EUR
USD $70.00	80.29 EUR
USD $80.00	91.49 EUR
USD $90.00	102.99 EUR
USD $100.00	114.49 EUR
GBP
Price Point	Gibraltar	United Kingdom
USD $2.00	1.69 GBP	1.99 GBP
USD $2.25	1.99 GBP	2.29 GBP
USD $2.50	2.29 GBP	2.49 GBP
USD $2.75	2.29 GBP	2.69 GBP
USD $3.00	2.49 GBP	2.99 GBP
USD $3.25	2.69 GBP	3.29 GBP
USD $3.50	2.99 GBP	3.49 GBP
USD $3.75	3.29 GBP	3.69 GBP
USD $4.00	3.29 GBP	3.99 GBP
USD $4.25	3.49 GBP	4.29 GBP
USD $4.50	3.69 GBP	4.49 GBP
USD $4.75	3.99 GBP	4.69 GBP
USD $5.00	4.29 GBP	4.99 GBP
USD $5.25	4.29 GBP	5.29 GBP
USD $5.50	4.49 GBP	5.49 GBP
USD $5.75	4.69 GBP	5.69 GBP
USD $6.00	4.99 GBP	5.99 GBP
USD $6.25	5.29 GBP	6.29 GBP
USD $6.50	5.29 GBP	6.49 GBP
USD $6.75	5.49 GBP	6.69 GBP
USD $7.00	5.69 GBP	6.99 GBP
USD $7.25	5.99 GBP	6.99 GBP
USD $7.50	6.29 GBP	7.29 GBP
USD $7.75	6.29 GBP	7.49 GBP
USD $8.00	6.49 GBP	7.99 GBP
USD $8.25	6.69 GBP	7.99 GBP
USD $8.50	6.99 GBP	8.29 GBP
USD $8.75	7.29 GBP	8.49 GBP
USD $9.00	7.29 GBP	8.69 GBP
USD $9.25	7.49 GBP	8.99 GBP
USD $9.50	7.69 GBP	9.29 GBP
USD $9.75	7.99 GBP	9.49 GBP
USD $10.00	8.29 GBP	9.69 GBP
USD $11.00	8.99 GBP	10.69 GBP
USD $12.00	9.69 GBP	11.69 GBP
USD $13.00	10.49 GBP	12.69 GBP
USD $14.00	11.49 GBP	13.69 GBP
USD $15.00	12.29 GBP	14.49 GBP
USD $16.00	12.99 GBP	15.49 GBP
USD $17.00	13.69 GBP	16.49 GBP
USD $18.00	14.49 GBP	17.49 GBP
USD $19.00	15.49 GBP	18.49 GBP
USD $20.00	16.29 GBP	19.49 GBP
USD $21.00	16.99 GBP	20.49 GBP
USD $22.00	17.99 GBP	21.49 GBP
USD $23.00	18.69 GBP	22.29 GBP
USD $24.00	19.49 GBP	23.29 GBP
USD $25.00	20.29 GBP	24.29 GBP
USD $26.00	20.99 GBP	25.29 GBP
USD $27.00	21.99 GBP	26.29 GBP
USD $28.00	22.69 GBP	27.29 GBP
USD $29.00	23.49 GBP	28.29 GBP
USD $30.00	24.29 GBP	28.99 GBP
USD $31.00	24.99 GBP	29.99 GBP
USD $32.00	25.99 GBP	30.99 GBP
USD $33.00	26.69 GBP	31.99 GBP
USD $34.00	27.49 GBP	32.99 GBP
USD $35.00	28.29 GBP	33.99 GBP
USD $36.00	28.99 GBP	34.99 GBP
USD $37.00	29.99 GBP	35.99 GBP
USD $38.00	30.69 GBP	36.99 GBP
USD $39.00	31.49 GBP	37.69 GBP
USD $40.00	32.29 GBP	38.69 GBP
USD $41.00	33.29 GBP	39.69 GBP
USD $42.00	33.99 GBP	40.69 GBP
USD $43.00	34.69 GBP	41.69 GBP
USD $44.00	35.49 GBP	42.69 GBP
USD $45.00	36.29 GBP	43.49 GBP
USD $46.00	37.29 GBP	44.49 GBP
USD $47.00	37.99 GBP	45.49 GBP
USD $48.00	38.69 GBP	46.49 GBP
USD $49.00	39.49 GBP	47.49 GBP
USD $50.00	40.49 GBP	48.49 GBP
USD $60.00	48.49 GBP	57.99 GBP
USD $70.00	56.49 GBP	67.69 GBP
USD $80.00	64.49 GBP	77.49 GBP
USD $90.00	72.49 GBP	86.99 GBP
USD $100.00	80.69 GBP	96.69 GBP
MXN
Price Point	Mexico
USD $2.00	39.25 MXN
USD $2.25	44.25 MXN
USD $2.50	48.99 MXN
USD $2.75	53.99 MXN
USD $3.00	58.75 MXN
USD $3.25	63.75 MXN
USD $3.50	68.75 MXN
USD $3.75	73.49 MXN
USD $4.00	78.49 MXN
USD $4.25	83.25 MXN
USD $4.50	88.25 MXN
USD $4.75	93.25 MXN
USD $5.00	97.99 MXN
USD $5.25	102.99 MXN
USD $5.50	107.75 MXN
USD $5.75	112.75 MXN
USD $6.00	117.49 MXN
USD $6.25	122.49 MXN
USD $6.50	127.49 MXN
USD $6.75	132.25 MXN
USD $7.00	137.25 MXN
USD $7.25	141.99 MXN
USD $7.50	146.99 MXN
USD $7.75	151.99 MXN
USD $8.00	156.75 MXN
USD $8.25	161.75 MXN
USD $8.50	166.49 MXN
USD $8.75	171.49 MXN
USD $9.00	176.25 MXN
USD $9.25	181.25 MXN
USD $9.50	186.25 MXN
USD $9.75	190.99 MXN
USD $10.00	195.99 MXN
USD $11.00	215.49 MXN
USD $12.00	234.99 MXN
USD $13.00	254.75 MXN
USD $14.00	274.25 MXN
USD $15.00	293.75 MXN
USD $16.00	313.49 MXN
USD $17.00	332.99 MXN
USD $18.00	352.49 MXN
USD $19.00	372.25 MXN
USD $20.00	391.75 MXN
USD $21.00	411.25 MXN
USD $22.00	430.99 MXN
USD $23.00	450.49 MXN
USD $24.00	469.99 MXN
USD $25.00	489.75 MXN
USD $26.00	509.25 MXN
USD $27.00	528.75 MXN
USD $28.00	548.49 MXN
USD $29.00	567.99 MXN
USD $30.00	587.49 MXN
USD $31.00	607.25 MXN
USD $32.00	626.75 MXN
USD $33.00	646.25 MXN
USD $34.00	665.99 MXN
USD $35.00	685.49 MXN
USD $36.00	704.99 MXN
USD $37.00	724.75 MXN
USD $38.00	744.25 MXN
USD $39.00	763.75 MXN
USD $40.00	783.25 MXN
USD $41.00	802.99 MXN
USD $42.00	822.49 MXN
USD $43.00	841.99 MXN
USD $44.00	861.75 MXN
USD $45.00	881.25 MXN
USD $46.00	900.75 MXN
USD $47.00	920.49 MXN
USD $48.00	939.99 MXN
USD $49.00	959.49 MXN
USD $50.00	979.25 MXN
USD $60.00	1174.99 MXN
USD $70.00	1370.75 MXN
USD $80.00	1566.49 MXN
USD $90.00	1762.49 MXN
USD $100.00	1958.25 MXN
NOK
Price Point	Svalbard and Jan Mayen	Norway
USD $2.00	22.50 NOK	28.00 NOK
USD $2.25	25.50 NOK	31.50 NOK
USD $2.50	28.00 NOK	35.00 NOK
USD $2.75	31.00 NOK	38.50 NOK
USD $3.00	34.00 NOK	42.00 NOK
USD $3.25	36.50 NOK	45.50 NOK
USD $3.50	39.50 NOK	49.00 NOK
USD $3.75	42.00 NOK	52.50 NOK
USD $4.00	45.00 NOK	56.00 NOK
USD $4.25	48.00 NOK	59.50 NOK
USD $4.50	50.50 NOK	63.00 NOK
USD $4.75	53.50 NOK	66.50 NOK
USD $5.00	56.00 NOK	70.00 NOK
USD $5.25	59.00 NOK	73.50 NOK
USD $5.50	62.00 NOK	77.00 NOK
USD $5.75	64.50 NOK	80.50 NOK
USD $6.00	67.50 NOK	84.00 NOK
USD $6.25	70.00 NOK	87.50 NOK
USD $6.50	73.00 NOK	91.00 NOK
USD $6.75	76.00 NOK	94.50 NOK
USD $7.00	78.50 NOK	98.00 NOK
USD $7.25	81.50 NOK	101.50 NOK
USD $7.50	84.00 NOK	105.00 NOK
USD $7.75	87.00 NOK	108.50 NOK
USD $8.00	90.00 NOK	112.00 NOK
USD $8.25	92.50 NOK	115.50 NOK
USD $8.50	95.50 NOK	119.00 NOK
USD $8.75	98.00 NOK	122.50 NOK
USD $9.00	101.00 NOK	126.00 NOK
USD $9.25	103.50 NOK	129.50 NOK
USD $9.50	106.50 NOK	133.00 NOK
USD $9.75	109.50 NOK	136.50 NOK
USD $10.00	112.00 NOK	140.00 NOK
USD $11.00	123.50 NOK	154.00 NOK
USD $12.00	134.50 NOK	168.00 NOK
USD $13.00	145.50 NOK	182.00 NOK
USD $14.00	157.00 NOK	196.00 NOK
USD $15.00	168.00 NOK	210.00 NOK
USD $16.00	179.50 NOK	224.00 NOK
USD $17.00	190.50 NOK	238.00 NOK
USD $18.00	201.50 NOK	252.00 NOK
USD $19.00	213.00 NOK	266.00 NOK
USD $20.00	224.00 NOK	280.00 NOK
USD $21.00	235.00 NOK	294.00 NOK
USD $22.00	246.50 NOK	308.00 NOK
USD $23.00	257.50 NOK	322.00 NOK
USD $24.00	269.00 NOK	336.00 NOK
USD $25.00	280.00 NOK	350.00 NOK
USD $26.00	291.00 NOK	364.00 NOK
USD $27.00	302.50 NOK	378.00 NOK
USD $28.00	313.50 NOK	392.00 NOK
USD $29.00	324.50 NOK	406.00 NOK
USD $30.00	336.00 NOK	420.00 NOK
USD $31.00	347.00 NOK	434.00 NOK
USD $32.00	358.50 NOK	448.00 NOK
USD $33.00	369.50 NOK	461.50 NOK
USD $34.00	380.50 NOK	475.50 NOK
USD $35.00	392.00 NOK	489.50 NOK
USD $36.00	403.00 NOK	503.50 NOK
USD $37.00	414.00 NOK	517.50 NOK
USD $38.00	425.50 NOK	531.50 NOK
USD $39.00	436.50 NOK	545.50 NOK
USD $40.00	448.00 NOK	559.50 NOK
USD $41.00	459.00 NOK	573.50 NOK
USD $42.00	470.00 NOK	587.50 NOK
USD $43.00	481.50 NOK	601.50 NOK
USD $44.00	492.50 NOK	615.50 NOK
USD $45.00	503.50 NOK	629.50 NOK
USD $46.00	515.00 NOK	643.50 NOK
USD $47.00	526.00 NOK	657.50 NOK
USD $48.00	537.50 NOK	671.50 NOK
USD $49.00	548.50 NOK	685.50 NOK
USD $50.00	559.50 NOK	699.50 NOK
USD $60.00	671.50 NOK	839.50 NOK
USD $70.00	783.50 NOK	979.00 NOK
USD $80.00	895.50 NOK	1119.00 NOK
USD $90.00	1007.00 NOK	1259.00 NOK
USD $100.00	1119.00 NOK	1398.50 NOK
NZD
Price Point	New Zealand
USD $2.00	3.49 NZD
USD $2.25	3.99 NZD
USD $2.50	4.49 NZD
USD $2.75	4.75 NZD
USD $3.00	5.25 NZD
USD $3.25	5.75 NZD
USD $3.50	6.25 NZD
USD $3.75	6.49 NZD
USD $4.00	6.99 NZD
USD $4.25	7.49 NZD
USD $4.50	7.75 NZD
USD $4.75	8.25 NZD
USD $5.00	8.75 NZD
USD $5.25	9.25 NZD
USD $5.50	9.49 NZD
USD $5.75	9.99 NZD
USD $6.00	10.49 NZD
USD $6.25	10.99 NZD
USD $6.50	11.25 NZD
USD $6.75	11.75 NZD
USD $7.00	12.25 NZD
USD $7.25	12.49 NZD
USD $7.50	12.99 NZD
USD $7.75	13.49 NZD
USD $8.00	13.99 NZD
USD $8.25	14.25 NZD
USD $8.50	14.75 NZD
USD $8.75	15.25 NZD
USD $9.00	15.49 NZD
USD $9.25	15.99 NZD
USD $9.50	16.49 NZD
USD $9.75	16.99 NZD
USD $10.00	17.25 NZD
USD $11.00	18.99 NZD
USD $12.00	20.75 NZD
USD $13.00	22.49 NZD
USD $14.00	24.25 NZD
USD $15.00	25.99 NZD
USD $16.00	27.75 NZD
USD $17.00	29.49 NZD
USD $18.00	30.99 NZD
USD $19.00	32.75 NZD
USD $20.00	34.49 NZD
USD $21.00	36.25 NZD
USD $22.00	37.99 NZD
USD $23.00	39.75 NZD
USD $24.00	41.49 NZD
USD $25.00	43.25 NZD
USD $26.00	44.99 NZD
USD $27.00	46.49 NZD
USD $28.00	48.25 NZD
USD $29.00	49.99 NZD
USD $30.00	51.75 NZD
USD $31.00	53.49 NZD
USD $32.00	55.25 NZD
USD $33.00	56.99 NZD
USD $34.00	58.75 NZD
USD $35.00	60.49 NZD
USD $36.00	61.99 NZD
USD $37.00	63.75 NZD
USD $38.00	65.49 NZD
USD $39.00	67.25 NZD
USD $40.00	68.99 NZD
USD $41.00	70.75 NZD
USD $42.00	72.49 NZD
USD $43.00	74.25 NZD
USD $44.00	75.99 NZD
USD $45.00	77.49 NZD
USD $46.00	79.25 NZD
USD $47.00	80.99 NZD
USD $48.00	82.75 NZD
USD $49.00	84.49 NZD
USD $50.00	86.25 NZD
USD $60.00	103.49 NZD
USD $70.00	120.75 NZD
USD $80.00	137.75 NZD
USD $90.00	154.99 NZD
USD $100.00	172.25 NZD
RON
Price Point	Romania
USD $2.00	19 RON
USD $2.25	19 RON
USD $2.50	19 RON
USD $2.75	19 RON
USD $3.00	19 RON
USD $3.25	19 RON
USD $3.50	29 RON
USD $3.75	29 RON
USD $4.00	29 RON
USD $4.25	29 RON
USD $4.50	29 RON
USD $4.75	29 RON
USD $5.00	39 RON
USD $5.25	39 RON
USD $5.50	39 RON
USD $5.75	39 RON
USD $6.00	39 RON
USD $6.25	39 RON
USD $6.50	39 RON
USD $6.75	49 RON
USD $7.00	49 RON
USD $7.25	49 RON
USD $7.50	49 RON
USD $7.75	49 RON
USD $8.00	49 RON
USD $8.25	49 RON
USD $8.50	59 RON
USD $8.75	59 RON
USD $9.00	59 RON
USD $9.25	59 RON
USD $9.50	59 RON
USD $9.75	59 RON
USD $10.00	69 RON
USD $11.00	69 RON
USD $12.00	79 RON
USD $13.00	79 RON
USD $14.00	89 RON
USD $15.00	99 RON
USD $16.00	99 RON
USD $17.00	109 RON
USD $18.00	109 RON
USD $19.00	119 RON
USD $20.00	129 RON
USD $21.00	129 RON
USD $22.00	139 RON
USD $23.00	139 RON
USD $24.00	149 RON
USD $25.00	159 RON
USD $26.00	159 RON
USD $27.00	169 RON
USD $28.00	169 RON
USD $29.00	179 RON
USD $30.00	189 RON
USD $31.00	189 RON
USD $32.00	199 RON
USD $33.00	199 RON
USD $34.00	209 RON
USD $35.00	219 RON
USD $36.00	219 RON
USD $37.00	229 RON
USD $38.00	229 RON
USD $39.00	239 RON
USD $40.00	249 RON
USD $41.00	249 RON
USD $42.00	259 RON
USD $43.00	259 RON
USD $44.00	269 RON
USD $45.00	279 RON
USD $46.00	279 RON
USD $47.00	289 RON
USD $48.00	289 RON
USD $49.00	299 RON
USD $50.00	309 RON
USD $60.00	369 RON
USD $70.00	429 RON
USD $80.00	489 RON
USD $90.00	549 RON
USD $100.00	609 RON
SEK
Price Point	Sweden
USD $2.00	28.00 SEK
USD $2.25	31.50 SEK
USD $2.50	35.00 SEK
USD $2.75	38.50 SEK
USD $3.00	42.00 SEK
USD $3.25	45.50 SEK
USD $3.50	49.00 SEK
USD $3.75	52.50 SEK
USD $4.00	56.00 SEK
USD $4.25	59.50 SEK
USD $4.50	63.00 SEK
USD $4.75	66.50 SEK
USD $5.00	70.00 SEK
USD $5.25	73.50 SEK
USD $5.50	77.00 SEK
USD $5.75	80.50 SEK
USD $6.00	83.50 SEK
USD $6.25	87.00 SEK
USD $6.50	90.50 SEK
USD $6.75	94.00 SEK
USD $7.00	97.50 SEK
USD $7.25	101.00 SEK
USD $7.50	104.50 SEK
USD $7.75	108.00 SEK
USD $8.00	111.50 SEK
USD $8.25	115.00 SEK
USD $8.50	118.50 SEK
USD $8.75	122.00 SEK
USD $9.00	125.50 SEK
USD $9.25	129.00 SEK
USD $9.50	132.50 SEK
USD $9.75	136.00 SEK
USD $10.00	139.50 SEK
USD $11.00	153.50 SEK
USD $12.00	167.00 SEK
USD $13.00	181.00 SEK
USD $14.00	195.00 SEK
USD $15.00	209.00 SEK
USD $16.00	223.00 SEK
USD $17.00	237.00 SEK
USD $18.00	250.50 SEK
USD $19.00	264.50 SEK
USD $20.00	278.50 SEK
USD $21.00	292.50 SEK
USD $22.00	306.50 SEK
USD $23.00	320.50 SEK
USD $24.00	334.00 SEK
USD $25.00	348.00 SEK
USD $26.00	362.00 SEK
USD $27.00	376.00 SEK
USD $28.00	390.00 SEK
USD $29.00	403.50 SEK
USD $30.00	417.50 SEK
USD $31.00	431.50 SEK
USD $32.00	445.50 SEK
USD $33.00	459.50 SEK
USD $34.00	473.50 SEK
USD $35.00	487.00 SEK
USD $36.00	501.00 SEK
USD $37.00	515.00 SEK
USD $38.00	529.00 SEK
USD $39.00	543.00 SEK
USD $40.00	557.00 SEK
USD $41.00	570.50 SEK
USD $42.00	584.50 SEK
USD $43.00	598.50 SEK
USD $44.00	612.50 SEK
USD $45.00	626.50 SEK
USD $46.00	640.50 SEK
USD $47.00	654.00 SEK
USD $48.00	668.00 SEK
USD $49.00	682.00 SEK
USD $50.00	696.00 SEK
USD $60.00	835.00 SEK
USD $70.00	974.00 SEK
USD $80.00	1113.50 SEK
USD $90.00	1252.50 SEK
USD $100.00	1391.50 SEK
THB
Price Point	Thailand
USD $2.00	79 THB
USD $2.25	89 THB
USD $2.50	99 THB
USD $2.75	109 THB
USD $3.00	119 THB
USD $3.25	129 THB
USD $3.50	139 THB
USD $3.75	149 THB
USD $4.00	159 THB
USD $4.25	169 THB
USD $4.50	179 THB
USD $4.75	189 THB
USD $5.00	199 THB
USD $5.25	209 THB
USD $5.50	219 THB
USD $5.75	229 THB
USD $6.00	239 THB
USD $6.25	249 THB
USD $6.50	259 THB
USD $6.75	269 THB
USD $7.00	279 THB
USD $7.25	289 THB
USD $7.50	299 THB
USD $7.75	309 THB
USD $8.00	319 THB
USD $8.25	329 THB
USD $8.50	339 THB
USD $8.75	349 THB
USD $9.00	359 THB
USD $9.25	369 THB
USD $9.50	379 THB
USD $9.75	389 THB
USD $10.00	399 THB
USD $11.00	439 THB
USD $12.00	479 THB
USD $13.00	519 THB
USD $14.00	559 THB
USD $15.00	599 THB
USD $16.00	639 THB
USD $17.00	679 THB
USD $18.00	719 THB
USD $19.00	759 THB
USD $20.00	799 THB
USD $21.00	839 THB
USD $22.00	879 THB
USD $23.00	919 THB
USD $24.00	959 THB
USD $25.00	999 THB
USD $26.00	1039 THB
USD $27.00	1079 THB
USD $28.00	1119 THB
USD $29.00	1159 THB
USD $30.00	1199 THB
USD $31.00	1239 THB
USD $32.00	1279 THB
USD $33.00	1319 THB
USD $34.00	1359 THB
USD $35.00	1399 THB
USD $36.00	1439 THB
USD $37.00	1479 THB
USD $38.00	1519 THB
USD $39.00	1559 THB
USD $40.00	1599 THB
USD $41.00	1639 THB
USD $42.00	1679 THB
USD $43.00	1719 THB
USD $44.00	1759 THB
USD $45.00	1799 THB
USD $46.00	1839 THB
USD $47.00	1879 THB
USD $48.00	1919 THB
USD $49.00	1959 THB
USD $50.00	1999 THB
USD $60.00	2389 THB
USD $70.00	2789 THB
USD $80.00	3189 THB
USD $90.00	3589 THB
USD $100.00	3989 THB
USD
Price Point	United States	Taiwan	Indonesia, Japan, Puerto Rico, Singapore	Saudi Arabia	India	Iceland
USD $2.00	1.99 USD	2.25 USD	2.25 USD	2.49 USD	2.49 USD	2.49 USD
USD $2.25	2.25 USD	2.49 USD	2.49 USD	2.75 USD	2.75 USD	2.99 USD
USD $2.50	2.49 USD	2.75 USD	2.75 USD	2.99 USD	2.99 USD	3.25 USD
USD $2.75	2.75 USD	2.99 USD	3.25 USD	3.25 USD	3.49 USD	3.49 USD
USD $3.00	2.99 USD	3.25 USD	3.49 USD	3.49 USD	3.75 USD	3.75 USD
USD $3.25	3.25 USD	3.49 USD	3.75 USD	3.75 USD	3.99 USD	4.25 USD
USD $3.50	3.49 USD	3.75 USD	3.99 USD	4.25 USD	4.25 USD	4.49 USD
USD $3.75	3.75 USD	3.99 USD	4.25 USD	4.49 USD	4.49 USD	4.75 USD
USD $4.00	3.99 USD	4.25 USD	4.49 USD	4.75 USD	4.99 USD	4.99 USD
USD $4.25	4.25 USD	4.49 USD	4.75 USD	4.99 USD	5.25 USD	5.49 USD
USD $4.50	4.49 USD	4.75 USD	4.99 USD	5.25 USD	5.49 USD	5.75 USD
USD $4.75	4.75 USD	4.99 USD	5.25 USD	5.49 USD	5.75 USD	5.99 USD
USD $5.00	4.99 USD	5.25 USD	5.49 USD	5.75 USD	5.99 USD	6.25 USD
USD $5.25	5.25 USD	5.75 USD	5.99 USD	6.25 USD	6.49 USD	6.75 USD
USD $5.50	5.49 USD	5.99 USD	6.25 USD	6.49 USD	6.75 USD	6.99 USD
USD $5.75	5.75 USD	6.25 USD	6.49 USD	6.75 USD	6.99 USD	7.25 USD
USD $6.00	5.99 USD	6.49 USD	6.75 USD	6.99 USD	7.25 USD	7.49 USD
USD $6.25	6.25 USD	6.75 USD	6.99 USD	7.25 USD	7.49 USD	7.99 USD
USD $6.50	6.49 USD	6.99 USD	7.25 USD	7.49 USD	7.99 USD	8.25 USD
USD $6.75	6.75 USD	7.25 USD	7.49 USD	7.99 USD	8.25 USD	8.49 USD
USD $7.00	6.99 USD	7.49 USD	7.75 USD	8.25 USD	8.49 USD	8.75 USD
USD $7.25	7.25 USD	7.75 USD	7.99 USD	8.49 USD	8.75 USD	9.25 USD
USD $7.50	7.49 USD	7.99 USD	8.25 USD	8.75 USD	8.99 USD	9.49 USD
USD $7.75	7.75 USD	8.25 USD	8.75 USD	8.99 USD	9.49 USD	9.75 USD
USD $8.00	7.99 USD	8.49 USD	8.99 USD	9.25 USD	9.75 USD	9.99 USD
USD $8.25	8.25 USD	8.75 USD	9.25 USD	9.49 USD	9.99 USD	10.49 USD
USD $8.50	8.49 USD	8.99 USD	9.49 USD	9.99 USD	10.25 USD	10.75 USD
USD $8.75	8.75 USD	9.25 USD	9.75 USD	10.25 USD	10.49 USD	10.99 USD
USD $9.00	8.99 USD	9.49 USD	9.99 USD	10.49 USD	10.99 USD	11.25 USD
USD $9.25	9.25 USD	9.75 USD	10.25 USD	10.75 USD	11.25 USD	11.75 USD
USD $9.50	9.49 USD	9.99 USD	10.49 USD	10.99 USD	11.49 USD	11.99 USD
USD $9.75	9.75 USD	10.25 USD	10.75 USD	11.25 USD	11.75 USD	12.25 USD
USD $10.00	9.99 USD	10.49 USD	10.99 USD	11.49 USD	11.99 USD	12.49 USD
USD $11.00	10.99 USD	11.75 USD	12.25 USD	12.75 USD	13.25 USD	13.75 USD
USD $12.00	11.99 USD	12.75 USD	13.25 USD	13.99 USD	14.49 USD	14.99 USD
USD $13.00	12.99 USD	13.75 USD	14.49 USD	14.99 USD	15.75 USD	16.25 USD
USD $14.00	13.99 USD	14.75 USD	15.49 USD	16.25 USD	16.99 USD	17.49 USD
USD $15.00	14.99 USD	15.75 USD	16.49 USD	17.25 USD	17.99 USD	18.75 USD
USD $16.00	15.99 USD	16.99 USD	17.75 USD	18.49 USD	19.25 USD	19.99 USD
USD $17.00	16.99 USD	17.99 USD	18.75 USD	19.75 USD	20.49 USD	21.25 USD
USD $18.00	17.99 USD	18.99 USD	19.99 USD	20.75 USD	21.75 USD	22.49 USD
USD $19.00	18.99 USD	19.99 USD	20.99 USD	21.99 USD	22.99 USD	23.75 USD
USD $20.00	19.99 USD	20.99 USD	21.99 USD	22.99 USD	23.99 USD	24.99 USD
USD $21.00	20.99 USD	22.25 USD	23.25 USD	24.25 USD	25.25 USD	26.25 USD
USD $22.00	21.99 USD	23.25 USD	24.25 USD	25.49 USD	26.49 USD	27.49 USD
USD $23.00	22.99 USD	24.25 USD	25.49 USD	26.49 USD	27.75 USD	28.75 USD
USD $24.00	23.99 USD	25.25 USD	26.49 USD	27.75 USD	28.99 USD	29.99 USD
USD $25.00	24.99 USD	26.25 USD	27.75 USD	28.75 USD	29.99 USD	31.25 USD
USD $26.00	25.99 USD	27.49 USD	28.75 USD	29.99 USD	31.25 USD	32.49 USD
USD $27.00	26.99 USD	28.49 USD	29.75 USD	31.25 USD	32.49 USD	33.75 USD
USD $28.00	27.99 USD	29.49 USD	30.99 USD	32.25 USD	33.75 USD	34.99 USD
USD $29.00	28.99 USD	30.49 USD	31.99 USD	33.49 USD	34.99 USD	36.25 USD
USD $30.00	29.99 USD	31.49 USD	32.99 USD	34.49 USD	35.99 USD	37.49 USD
USD $31.00	30.99 USD	32.75 USD	34.25 USD	35.75 USD	37.25 USD	38.75 USD
USD $32.00	31.99 USD	33.75 USD	35.25 USD	36.99 USD	38.49 USD	39.99 USD
USD $33.00	32.99 USD	34.75 USD	36.49 USD	37.99 USD	39.75 USD	41.25 USD
USD $34.00	33.99 USD	35.75 USD	37.49 USD	39.25 USD	40.99 USD	42.49 USD
USD $35.00	34.99 USD	36.75 USD	38.49 USD	40.25 USD	41.99 USD	43.75 USD
USD $36.00	35.99 USD	37.99 USD	39.75 USD	41.49 USD	43.25 USD	44.99 USD
USD $37.00	36.99 USD	38.99 USD	40.75 USD	42.75 USD	44.49 USD	46.25 USD
USD $38.00	37.99 USD	39.99 USD	41.99 USD	43.75 USD	45.75 USD	47.49 USD
USD $39.00	38.99 USD	40.99 USD	42.99 USD	44.99 USD	46.99 USD	48.75 USD
USD $40.00	39.99 USD	41.99 USD	43.99 USD	45.99 USD	47.99 USD	49.99 USD
USD $41.00	40.99 USD	43.25 USD	45.25 USD	47.25 USD	49.25 USD	51.25 USD
USD $42.00	41.99 USD	44.25 USD	46.25 USD	48.49 USD	50.49 USD	52.49 USD
USD $43.00	42.99 USD	45.25 USD	47.49 USD	49.49 USD	51.75 USD	53.75 USD
USD $44.00	43.99 USD	46.25 USD	48.49 USD	50.75 USD	52.99 USD	54.99 USD
USD $45.00	44.99 USD	47.25 USD	49.75 USD	51.75 USD	53.99 USD	56.25 USD
USD $46.00	45.99 USD	48.49 USD	50.75 USD	52.99 USD	55.25 USD	57.49 USD
USD $47.00	46.99 USD	49.49 USD	51.75 USD	54.25 USD	56.49 USD	58.75 USD
USD $48.00	47.99 USD	50.49 USD	52.99 USD	55.25 USD	57.75 USD	59.99 USD
USD $49.00	48.99 USD	51.49 USD	53.99 USD	56.49 USD	58.99 USD	61.25 USD
USD $50.00	49.99 USD	52.49 USD	54.99 USD	57.49 USD	59.99 USD	62.49 USD
USD $60.00	59.99 USD	62.99 USD	65.99 USD	68.99 USD	71.99 USD	74.99 USD
USD $70.00	69.99 USD	73.49 USD	76.99 USD	80.49 USD	83.99 USD	87.49 USD
USD $80.00	79.99 USD	83.99 USD	87.99 USD	91.99 USD	95.99 USD	99.99 USD
USD $90.00	89.99 USD	94.49 USD	98.99 USD	103.49 USD	107.99 USD	112.49 USD
USD $100.00	99.99 USD	104.99 USD	109.99 USD	114.99 USD	119.99 USD	124.99 USD
VND
Price Point	Vietnam
USD $2.00	55699 VND
USD $2.25	62599 VND
USD $2.50	69599 VND
USD $2.75	76499 VND
USD $3.00	83499 VND
USD $3.25	90399 VND
USD $3.50	97399 VND
USD $3.75	104299 VND
USD $4.00	111299 VND
USD $4.25	118199 VND
USD $4.50	125199 VND
USD $4.75	132099 VND
USD $5.00	139099 VND
USD $5.25	145999 VND
USD $5.50	152999 VND
USD $5.75	159899 VND
USD $6.00	166899 VND
USD $6.25	173799 VND
USD $6.50	180799 VND
USD $6.75	187699 VND
USD $7.00	194699 VND
USD $7.25	201599 VND
USD $7.50	208599 VND
USD $7.75	215499 VND
USD $8.00	222499 VND
USD $8.25	229399 VND
USD $8.50	236399 VND
USD $8.75	243299 VND
USD $9.00	250299 VND
USD $9.25	257199 VND
USD $9.50	264199 VND
USD $9.75	271099 VND
USD $10.00	278099 VND
USD $11.00	305899 VND
USD $12.00	333699 VND
USD $13.00	361499 VND
USD $14.00	389299 VND
USD $15.00	417099 VND
USD $16.00	444899 VND
USD $17.00	472699 VND
USD $18.00	500499 VND
USD $19.00	528299 VND
USD $20.00	556099 VND
USD $21.00	583899 VND
USD $22.00	611699 VND
USD $23.00	639499 VND
USD $24.00	667299 VND
USD $25.00	695099 VND
USD $26.00	722899 VND
USD $27.00	750799 VND
USD $28.00	778599 VND
USD $29.00	806399 VND
USD $30.00	834199 VND
USD $31.00	861999 VND
USD $32.00	889799 VND
USD $33.00	917599 VND
USD $34.00	945399 VND
USD $35.00	973199 VND
USD $36.00	1000999 VND
USD $37.00	1028799 VND
USD $38.00	1056599 VND
USD $39.00	1084399 VND
USD $40.00	1112199 VND
USD $41.00	1139999 VND
USD $42.00	1167799 VND
USD $43.00	1195599 VND
USD $44.00	1223399 VND
USD $45.00	1251199 VND
USD $46.00	1278999 VND
USD $47.00	1306799 VND
USD $48.00	1334599 VND
USD $49.00	1362399 VND
USD $50.00	1390199 VND
USD $60.00	1668299 VND
USD $70.00	1946299 VND
USD $80.00	2224299 VND
USD $90.00	2502399 VND
USD $100.00	2780399 VND
 
 */
